import WarningIcon from '@mui/icons-material/Warning';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import type { PaymentTestAccountBanner_charge$key } from './__generated__/PaymentTestAccountBanner_charge.graphql.ts';
import type { PaymentTestAccountBanner_pixQrCode$key } from './__generated__/PaymentTestAccountBanner_pixQrCode.graphql.ts';

type PaymentLinkTestAccountBannerProps = {
  charge: PaymentTestAccountBanner_charge$key;
  pixQrCode: PaymentTestAccountBanner_pixQrCode$key;
};

const PaymentTestAccountBanner = (
  props: PaymentLinkTestAccountBannerProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const charge = useFragment<PaymentTestAccountBanner_charge$key>(
    graphql`
      fragment PaymentTestAccountBanner_charge on Charge {
        id
        isFromTestAccount
      }
    `,
    props.charge,
  );

  const pixQrCode = useFragment<PaymentTestAccountBanner_pixQrCode$key>(
    graphql`
      fragment PaymentTestAccountBanner_pixQrCode on PixQrCode {
        id
        isFromTestAccount
      }
    `,
    props.pixQrCode,
  );

  if (!charge?.isFromTestAccount && !pixQrCode?.isFromTestAccount) {
    return null;
  }

  const getTitle = () => {
    if (pixQrCode) {
      return t('Test Qr Code');
    }

    return t('Test charge');
  };

  return (
    <Stack
      sx={{
        backgroundColor: theme.palette.error.main,
        borderRadius: 1,
        justifyContent: 'center',
        p: 1,
        width: '100%',
      }}
    >
      <Stack
        direction='row'
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          color: theme.palette.common.white,
        }}
      >
        <WarningIcon />
        <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
          {getTitle()}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default PaymentTestAccountBanner;
